$(function () {
    $("table.table-sortable").each(function () {
        const table = this;
        const $table = $(table);
        const $tbody = $table.find("tbody");

        if (!$tbody.length) return;

        const $rows = $tbody.find("tr[id]");
        if (!$rows.length) return;

        // 실제 데이터 행(tr[id])에만 checkbox 다음으로 핸들 자동 추가
        $rows.each(function () {
            const $tr = $(this);
            const $firstTd = $tr.find("td").eq(0);

            if (!$firstTd.length) return;
            if ($firstTd.find(".sortable-handle").length) return;

            const $checkbox = $firstTd.find('input[type="checkbox"]').first();

            const handleHtml = `
                <button type="button"
                        class="sortable-handle btn btn-sm btn-icon rounded-circle btn-light ms-1">
                    <i class="ti ti-arrows-sort fs-lg"></i>
                </button>
            `;

            if ($checkbox.length) {
                $checkbox.after(handleHtml);
            } else {
                $firstTd.append(handleHtml);
            }
        });

        Sortable.create($tbody[0], {
            animation: 150,
            handle: ".sortable-handle",
            // ghostClass: "table-active",
            // chosenClass: "table-warning",
            onEnd: function () {
                const ids = [];

                $tbody.find("tr").each(function () {
                    const id = $(this).attr("id");
                    if (id) ids.push(id);
                });

                $.ajax({
                    type: "POST",
                    url: $table.data("sort-action"),
                    data: {
                        ids: ids,
                    },
                    success: function () {
                        ui.toast.success("정렬되었습니다.");
                    },
                    error: function () {
                        ui.toast.error("정렬 저장 중 오류가 발생했습니다.");
                    }
                });
            }
        });

    });
});
